import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { DivisionChange } from '@sorare/core/src/__generated__/globalTypes';
import { BrandS } from '@sorare/core/src/atoms/typography';
import type { Color } from '@sorare/core/src/style/types';

import { messages } from 'components/managerTeam/Status/messages';

const Root = styled.div`
  position: relative;
  padding: var(--unit);
`;

const divisionChangeAttr: Record<DivisionChange, { color: Color }> = {
  [DivisionChange.PROMOTED]: {
    color: 'var(--c-onBase-success)',
  },
  [DivisionChange.RELEGATED]: { color: 'var(--c-red-400)' },
  [DivisionChange.STABLE]: { color: 'var(--c-nd-600)' },
};
type Props = { divisionChange: DivisionChange };
export const DivisionChangeBanner = ({ divisionChange }: Props) => {
  const message = messages[divisionChange];
  const { color = 'var(--c-nd-600)' } = divisionChangeAttr[divisionChange];

  return (
    <Root>
      <BrandS color={color} className="text-center">
        <FormattedMessage {...message} />
      </BrandS>
    </Root>
  );
};
